import { Factory } from '../../models';
import { FormatterHelper } from '../common/formatter.helper';

export class FactoriesHelper {

    protected formatterHelper: FormatterHelper;
    public factories: Factory[];

    constructor() {
        this.factories = [];
        this.formatterHelper = new FormatterHelper();
    }

    createFactory(data: any): Factory {
        let factory: Factory = {
            Id: data.pkID,
            Name: data.name,
            Longitude: this.formatterHelper.convertToISODecimal(data.LO),
            Latitude: this.formatterHelper.convertToISODecimal(data.LA)
        };
        return factory;
    }

    findFactory(factory: string[]): Factory[] {
        return this.factories.filter(f => factory.includes(f.Id));
    }


}